import { createStore } from 'vuex'

export default createStore({
    state: {
        navActiveIndex: '0',
        isPc:true
    },
    mutations: {
        navFunc(state,active) {
            state.navActiveIndex = active
        },
        isPcFunc(state,isPc) {
            state.isPc = isPc
        },
    },
    actions: {
    },
    modules: {
    }
})
